export default {
    eigenheim: {
        activeQuestion: 'Question1',
        nextQuestion: '',
        highestVisitedQuestion: 'Question1',
        isCompleted: false,
    },
    alltag: {
        activeQuestion: 'Question1',
        nextQuestion: '',
        highestVisitedQuestion: 'Question1',
        isCompleted: false,
    },
    absichern: {
        activeQuestion: 'Question1',
        nextQuestion: '',
        highestVisitedQuestion: 'Question1',
        isCompleted: false,
    },
    sparen: {
        activeQuestion: 'Question1',
        nextQuestion: '',
        highestVisitedQuestion: 'Question1',
        isCompleted: false,
    },
    engagieren: {
        activeQuestion: 'Question1',
        nextQuestion: '',
        highestVisitedQuestion: 'Question1',
        isCompleted: false,
    },
    extra: {
        activeQuestion: 'Question1',
        nextQuestion: '',
        highestVisitedQuestion: 'Question1',
        isCompleted: false,
    },
};
